import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, Fragment as _Fragment, renderList as _renderList, normalizeClass as _normalizeClass, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01fb6690"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "uf-approvalDetail"
}
const _hoisted_2 = { class: "uf-approvalDetail__header" }
const _hoisted_3 = { class: "uf-approvalDetail__process" }
const _hoisted_4 = { class: "uf-approvalDetail__process-date" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "uf-approvalDetail__process-i",
  style: {"margin-right":"5px"}
}, [
  /*#__PURE__*/_createElementVNode("i"),
  /*#__PURE__*/_createElementVNode("b")
], -1))
const _hoisted_6 = { class: "uf-approvalDetail__process-value" }
const _hoisted_7 = {
  key: 0,
  style: {"margin-right":"5px"}
}
const _hoisted_8 = { class: "uf-approvalDetail__info" }
const _hoisted_9 = { class: "uf-approvalDetail__info__title" }
const _hoisted_10 = {
  class: "uf-approvalDetail__info__content",
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_11 = { class: "uf-approvalDetail__info__footer" }
const _hoisted_12 = { style: {"color":"#3d6eeb"} }
const _hoisted_13 = {
  class: "uf-approvalDetail__info__content",
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_14 = {
  class: "uf-approvalDetail__info__content",
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_15 = {
  class: "uf-approvalDetail__info__content",
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_16 = {
  class: "uf-approvalDetail__info__content",
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-events__title" }, "事务内容", -1))
const _hoisted_18 = {
  key: 0,
  style: {"background":"#fff"}
}
const _hoisted_19 = { class: "uf-events-detail van-hairline--bottom" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-events-detail__title" }, " 问题描述： ", -1))
const _hoisted_21 = { class: "uf-events-detail__content" }
const _hoisted_22 = { class: "uf-events-detail van-hairline--bottom" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-events-detail__title" }, " 巡检点： ", -1))
const _hoisted_24 = { class: "uf-events-detail__content" }
const _hoisted_25 = { class: "uf-events-detail van-hairline--bottom" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-events-detail__title" }, " 检查对象： ", -1))
const _hoisted_27 = { class: "uf-events-detail__content" }
const _hoisted_28 = { class: "uf-events-detail van-hairline--bottom" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-events-detail__title" }, " 巡检任务： ", -1))
const _hoisted_30 = { class: "uf-events-detail__content" }
const _hoisted_31 = {
  key: 1,
  style: {"background":"#fff"}
}
const _hoisted_32 = { class: "uf-events-detail van-hairline--bottom" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-events-detail__title" }, " 问题描述： ", -1))
const _hoisted_34 = { class: "uf-events-detail__content" }
const _hoisted_35 = { class: "uf-events-detail van-hairline--bottom" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-events-detail__title" }, " 维保对象： ", -1))
const _hoisted_37 = { class: "uf-events-detail__content" }
const _hoisted_38 = { class: "uf-events-detail van-hairline--bottom" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-events-detail__title" }, " 维保工单： ", -1))
const _hoisted_40 = { class: "uf-events-detail__content" }
const _hoisted_41 = { class: "uf-events-detail van-hairline--bottom" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-events-detail__title" }, " 维保任务： ", -1))
const _hoisted_43 = { class: "uf-events-detail__content" }
const _hoisted_44 = {
  key: 2,
  style: {"background":"#fff"}
}
const _hoisted_45 = { class: "uf-events-detail van-hairline--bottom" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-events-detail__title" }, " 问题描述： ", -1))
const _hoisted_47 = { class: "uf-events-detail__content" }
const _hoisted_48 = { class: "uf-events-detail van-hairline--bottom" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-events-detail__title" }, " 巡检点： ", -1))
const _hoisted_50 = { class: "uf-events-detail__content" }
const _hoisted_51 = { class: "uf-events-detail van-hairline--bottom" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-events-detail__title" }, " 检查对象： ", -1))
const _hoisted_53 = { class: "uf-events-detail__content" }
const _hoisted_54 = { class: "uf-events-detail van-hairline--bottom" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-events-detail__title" }, " 巡检任务： ", -1))
const _hoisted_56 = { class: "uf-events-detail__content" }
const _hoisted_57 = { class: "uf-events-detail van-hairline--bottom" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-events-detail__title" }, " 巡检线路： ", -1))
const _hoisted_59 = { class: "uf-events-detail__content" }
const _hoisted_60 = { class: "uf-events-detail van-hairline--bottom" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-events-detail__title" }, " 维保对象： ", -1))
const _hoisted_62 = { class: "uf-events-detail__content" }
const _hoisted_63 = { class: "uf-events-detail van-hairline--bottom" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-events-detail__title" }, " 维保工单： ", -1))
const _hoisted_65 = { class: "uf-events-detail__content" }
const _hoisted_66 = { class: "uf-events-detail van-hairline--bottom" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-events-detail__title" }, " 维保任务： ", -1))
const _hoisted_68 = { class: "uf-events-detail__content" }
const _hoisted_69 = { class: "uf-events-detail van-hairline--bottom" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-events-detail__title" }, " 抄表对象： ", -1))
const _hoisted_71 = { class: "uf-events-detail__content" }
const _hoisted_72 = { class: "uf-events-detail van-hairline--bottom" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-events-detail__title" }, " 对应实体表： ", -1))
const _hoisted_74 = { class: "uf-events-detail__content" }
const _hoisted_75 = { class: "uf-events-detail van-hairline--bottom" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-events-detail__title" }, " 实体表位置： ", -1))
const _hoisted_77 = { class: "uf-events-detail__content" }
const _hoisted_78 = {
  key: 3,
  style: {"background":"#fff"}
}
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-events__title" }, "处理信息", -1))
const _hoisted_80 = { class: "uf-events__close" }
const _hoisted_81 = { class: "uf-events__close-item" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-events__close-title" }, "处理人：", -1))
const _hoisted_83 = { class: "uf-events__close-content" }
const _hoisted_84 = { key: 1 }
const _hoisted_85 = { class: "uf-events__close-item" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-events__close-title" }, "接单时间：", -1))
const _hoisted_87 = { class: "uf-events__close-content" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-events__close-item" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "uf-events__close-title" }, "操作：")
], -1))
const _hoisted_89 = { class: "operation-list" }
const _hoisted_90 = { class: "operation-list__item-title" }
const _hoisted_91 = ["onClick"]
const _hoisted_92 = { class: "item-content__content" }
const _hoisted_93 = { class: "item-content__content-code" }
const _hoisted_94 = { class: "item-content__content-name" }
const _hoisted_95 = { class: "operation-list__item-title" }
const _hoisted_96 = ["onClick"]
const _hoisted_97 = { class: "item-content__content" }
const _hoisted_98 = { class: "item-content__content-code" }
const _hoisted_99 = { class: "item-content__content-name" }
const _hoisted_100 = { class: "uf-events__close-item" }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-events__close-title" }, "延期申请：", -1))
const _hoisted_102 = { class: "uf-events__close-content" }
const _hoisted_103 = {
  key: 0,
  class: "uf-events__close-item"
}
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-events__close-title" }, "延期审核人：", -1))
const _hoisted_105 = { class: "uf-events__close-content" }
const _hoisted_106 = { style: {"margin-left":"5px"} }
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-events__title" }, "处理结果", -1))
const _hoisted_108 = { class: "uf-events__close" }
const _hoisted_109 = { class: "uf-events__close-item" }
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-events__close-title" }, "处理时间：", -1))
const _hoisted_111 = { class: "uf-events__close-content" }
const _hoisted_112 = { class: "uf-events__close-item" }
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-events__close-title" }, "处理原因：", -1))
const _hoisted_114 = { class: "uf-events__close-content" }
const _hoisted_115 = {
  key: 0,
  class: "uf-events__close-item"
}
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-events__close-title" }, "图片：", -1))
const _hoisted_117 = { class: "uf-events__close-content" }
const _hoisted_118 = { class: "uf-events__close-item" }
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-events__close-title" }, "备 注：", -1))
const _hoisted_120 = { class: "uf-events__close-content" }
const _hoisted_121 = {
  key: 1,
  class: "uf-events__close-item"
}
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-events__close-title" }, "处理审核人：", -1))
const _hoisted_123 = { class: "uf-events__close-content" }
const _hoisted_124 = { style: {"margin-left":"5px"} }
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-events__title" }, "评价信息", -1))
const _hoisted_126 = { class: "uf-events__close" }
const _hoisted_127 = { class: "uf-events__close-item" }
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-events__close-title" }, "评价时间：", -1))
const _hoisted_129 = { class: "uf-events__close-content" }
const _hoisted_130 = { class: "uf-events__close-item" }
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-events__close-title" }, "评价内容：", -1))
const _hoisted_132 = { class: "uf-events__close-content" }
const _hoisted_133 = {
  key: 0,
  style: {"padding-top":"5px"}
}
const _hoisted_134 = { class: "uf-events__close-item" }
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-events__close-title" }, "响应速度：", -1))
const _hoisted_136 = { class: "uf-events__close-content" }
const _hoisted_137 = { class: "uf-events__close-item" }
const _hoisted_138 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-events__close-title" }, "服务态度：", -1))
const _hoisted_139 = { class: "uf-events__close-content" }
const _hoisted_140 = { class: "uf-events__close-item" }
const _hoisted_141 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uf-events__close-title" }, "服务质量：", -1))
const _hoisted_142 = { class: "uf-events__close-content" }
const _hoisted_143 = {
  key: 7,
  class: "uf-button"
}
const _hoisted_144 = { class: "uf-button--footer" }
const _hoisted_145 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#fff"} }, "加载中...", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_tag = _resolveComponent("van-tag")!
  const _component_sub_form_item_group = _resolveComponent("sub-form-item-group")!
  const _component_uf_form = _resolveComponent("uf-form")!
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_rate = _resolveComponent("van-rate")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_exanube = _resolveComponent("exanube")!
  const _component_praise = _resolveComponent("praise")!
  const _component_approval = _resolveComponent("approval")!
  const _component_van_empty = _resolveComponent("van-empty")!
  const _component_van_loading = _resolveComponent("van-loading")!
  const _component_van_overlay = _resolveComponent("van-overlay")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.id)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_van_cell, {
              class: "uf-approvalDetail__cell",
              border: false,
              title: `事务状态：${_ctx.event_state_name}`
            }, null, 8, ["title"]),
            (_ctx.event_log.length > 0)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "uf-approvalDetail__header__bottom",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (
          _ctx.$router.push({
            name: _ctx.$RouterName.EVENTS_LOG,
            params: {
              id: _ctx.id
            }
          })
        ))
                }, [
                  _createVNode(_component_van_cell, {
                    center: "",
                    "is-link": ""
                  }, {
                    title: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                          _createElementVNode("i", null, _toDisplayString(_ctx.moment("20" + _ctx.event_log[0].opt_time_name).format("HH:mm")), 1),
                          _createElementVNode("b", null, _toDisplayString(_ctx.moment("20" + _ctx.event_log[0].opt_time_name).format("YY-MM-DD")), 1)
                        ]),
                        _hoisted_5,
                        _createElementVNode("div", _hoisted_6, [
                          (_ctx.event_log[0].opt_uid_array[0]?.department_name)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_7, _toDisplayString(_ctx.event_log[0].opt_uid_array[0]?.department_name) + " - " + _toDisplayString(_ctx.event_log[0].opt_uid_array[0]?.name), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("b", null, _toDisplayString(_ctx.event_log[0].show_content), 1)
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createTextVNode(_toDisplayString(_ctx.event_type_name) + " ", 1),
              (_ctx.is_overtime == '1')
                ? (_openBlock(), _createBlock(_component_van_tag, {
                    key: 0,
                    style: {"margin-left":"5px"},
                    color: "#FF5B34",
                    plain: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 领取超时")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.is_overtime_handler == '1')
                ? (_openBlock(), _createBlock(_component_van_tag, {
                    key: 1,
                    style: {"margin-left":"5px"},
                    color: "#FF5B34",
                    plain: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 处理超时")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("span", null, _toDisplayString(_ctx.event_code), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.user_id_detail[0].department_name) + "-" + _toDisplayString(_ctx.user_id_detail[0].name), 1),
              _createTextVNode(" 提交于 " + _toDisplayString(_ctx.create_time_time), 1)
            ]),
            _createElementVNode("div", _hoisted_13, " 类别： " + _toDisplayString(_ctx.event_category_name || "-"), 1),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("span", null, "所属部门：" + _toDisplayString(_ctx.user_id_detail[0].department_name), 1)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("span", null, "要求完成时间：" + _toDisplayString(_ctx.overtime_term_name || "-"), 1)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("span", null, "关联客户：" + _toDisplayString(_ctx.stores_name || "-"), 1)
            ])
          ]),
          _hoisted_17,
          (_ctx.event_type == '3')
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.tag_exception.problem_describe), 1)
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.tag_exception.order_name), 1)
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _hoisted_26,
                  _createElementVNode("div", _hoisted_27, "(" + _toDisplayString(_ctx.tag_exception.obj_type_name) + ")" + _toDisplayString(_ctx.tag_exception.obj_name), 1)
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _hoisted_29,
                  _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.tag_exception.pool_name), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.event_type == '51')
            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _hoisted_33,
                  _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.tag_exception.problem_describe), 1)
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _hoisted_36,
                  _createElementVNode("div", _hoisted_37, "(" + _toDisplayString(_ctx.tag_exception.obj_type_name) + ")" + _toDisplayString(_ctx.tag_exception.obj_name), 1)
                ]),
                _createElementVNode("div", _hoisted_38, [
                  _hoisted_39,
                  _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.tag_exception.order_name), 1)
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _hoisted_42,
                  _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.tag_exception.pool_name), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.event_type == '2' || _ctx.event_type == '4')
            ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                _createElementVNode("div", _hoisted_45, [
                  _hoisted_46,
                  _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.tag_exception.problem_describe), 1)
                ]),
                (_ctx.pool_type == '1')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", _hoisted_48, [
                        _hoisted_49,
                        _createElementVNode("div", _hoisted_50, _toDisplayString(_ctx.tag_exception.order_name), 1)
                      ]),
                      _createElementVNode("div", _hoisted_51, [
                        _hoisted_52,
                        _createElementVNode("div", _hoisted_53, "(" + _toDisplayString(_ctx.tag_exception.obj_type_name) + ")" + _toDisplayString(_ctx.tag_exception.order_name), 1)
                      ]),
                      _createElementVNode("div", _hoisted_54, [
                        _hoisted_55,
                        _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.tag_exception.pool_name), 1)
                      ]),
                      _createElementVNode("div", _hoisted_57, [
                        _hoisted_58,
                        _createElementVNode("div", _hoisted_59, _toDisplayString(_ctx.patrol_route_detail.name), 1)
                      ])
                    ], 64))
                  : _createCommentVNode("", true),
                (_ctx.pool_type == '2')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("div", _hoisted_60, [
                        _hoisted_61,
                        _createElementVNode("div", _hoisted_62, "(" + _toDisplayString(_ctx.tag_exception.obj_type_name) + ")" + _toDisplayString(_ctx.tag_exception.obj_name), 1)
                      ]),
                      _createElementVNode("div", _hoisted_63, [
                        _hoisted_64,
                        _createElementVNode("div", _hoisted_65, _toDisplayString(_ctx.tag_exception.order_name), 1)
                      ]),
                      _createElementVNode("div", _hoisted_66, [
                        _hoisted_67,
                        _createElementVNode("div", _hoisted_68, _toDisplayString(_ctx.tag_exception.pool_name), 1)
                      ])
                    ], 64))
                  : _createCommentVNode("", true),
                (_ctx.pool_type == '3')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createElementVNode("div", _hoisted_69, [
                        _hoisted_70,
                        _createElementVNode("div", _hoisted_71, _toDisplayString(_ctx.tag_exception.order_name), 1)
                      ]),
                      _createElementVNode("div", _hoisted_72, [
                        _hoisted_73,
                        _createElementVNode("div", _hoisted_74, _toDisplayString(_ctx.tag_exception.pool_name), 1)
                      ]),
                      _createElementVNode("div", _hoisted_75, [
                        _hoisted_76,
                        _createElementVNode("div", _hoisted_77, _toDisplayString(_ctx.tag_exception.pool_place_name), 1)
                      ])
                    ], 64))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.tempInfo && _ctx.tempInfo.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                _createVNode(_component_uf_form, {
                  "show-error": "",
                  "scroll-to-error": "",
                  "show-error-message": false
                }, {
                  default: _withCtx(() => [
                    (_ctx.tempInfo)
                      ? (_openBlock(), _createBlock(_component_sub_form_item_group, {
                          key: 0,
                          list: _ctx.tempInfo,
                          id: _ctx.id,
                          "is-event-detail": "",
                          ref: "subFormItemGroupRef"
                        }, null, 8, ["list", "id"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.event_state !== '10' && _ctx.event_state !== '50')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                _hoisted_79,
                _createElementVNode("div", _hoisted_80, [
                  _createElementVNode("div", _hoisted_81, [
                    _hoisted_82,
                    _createElementVNode("div", _hoisted_83, [
                      (_ctx.handle.handler_uid_array.length > 0)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(_ctx.handle.handler_uid_array[0].department_name) + " - " + _toDisplayString(_ctx.handle.handler_uid_array[0].name), 1)
                          ], 64))
                        : (_openBlock(), _createElementBlock("i", _hoisted_84, "-"))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_85, [
                    _hoisted_86,
                    _createElementVNode("div", _hoisted_87, _toDisplayString(_ctx.handle.accept_time_name || "-"), 1)
                  ]),
                  (_ctx.handle.operation_lists.length > 0)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _hoisted_88,
                        _createElementVNode("div", _hoisted_89, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.handle.operation_lists, (operation, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "operation-list__item",
                              key: index
                            }, [
                              (operation.type == 1)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createElementVNode("div", _hoisted_90, " 转工单 " + _toDisplayString(operation.fault_time_name), 1),
                                    _createElementVNode("div", {
                                      class: "item-content",
                                      onClick: ($event: any) => (_ctx.toOperationDetail(1, operation.id))
                                    }, [
                                      _createVNode(_component_van_image, {
                                        width: "40",
                                        height: "40",
                                        src: require('../../assets/icons/icon_repair.png')
                                      }, null, 8, ["src"]),
                                      _createElementVNode("div", _hoisted_92, [
                                        _createElementVNode("div", _hoisted_93, _toDisplayString(operation.orderid), 1),
                                        _createElementVNode("div", _hoisted_94, _toDisplayString(operation.faulttype_name), 1)
                                      ]),
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["item-content__button", {
                      yellow: operation.repairstate_name == '待接单'
                    }])
                                      }, _toDisplayString(operation.repairstate_name), 3)
                                    ], 8, _hoisted_91)
                                  ], 64))
                                : _createCommentVNode("", true),
                              (operation.type == 2)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createElementVNode("div", _hoisted_95, " 转审批 " + _toDisplayString(operation.create_time_name), 1),
                                    _createElementVNode("div", {
                                      class: "item-content",
                                      onClick: ($event: any) => (_ctx.toOperationDetail(2, operation.id))
                                    }, [
                                      _createVNode(_component_van_image, {
                                        width: "40",
                                        height: "40",
                                        src: operation.icon
                                      }, null, 8, ["src"]),
                                      _createElementVNode("div", _hoisted_97, [
                                        _createElementVNode("div", _hoisted_98, _toDisplayString(operation.code), 1),
                                        _createElementVNode("div", _hoisted_99, _toDisplayString(operation.name), 1)
                                      ]),
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["item-content__button", {
                      orange: operation.state_name == '审批中'
                    }])
                                      }, _toDisplayString(operation.state_name), 3)
                                    ], 8, _hoisted_96)
                                  ], 64))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ])
                      ], 64))
                    : _createCommentVNode("", true),
                  (Number(_ctx.delay_num) > 0)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("div", _hoisted_100, [
                          _hoisted_101,
                          _createElementVNode("div", _hoisted_102, _toDisplayString(_ctx.delay_num) + "次，申请延长至 " + _toDisplayString(_ctx.delay_time_name), 1)
                        ]),
                        (_ctx.delay_approval_uids_all.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
                              _hoisted_104,
                              _createElementVNode("div", _hoisted_105, [
                                _createElementVNode("div", {
                                  class: "approval-content",
                                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.approvalState.show2 = true))
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.delay_approval_uids_all, (approval, index) => {
                                    return _withDirectives((_openBlock(), _createBlock(_component_van_image, {
                                      key: approval.id,
                                      round: "",
                                      width: "24px",
                                      height: "24px",
                                      style: _normalizeStyle({ marginLeft: index > 0 ? '-6px' : '0px' }),
                                      src: approval.head_pic
                                    }, null, 8, ["style", "src"])), [
                                      [_vShow, index < 6]
                                    ])
                                  }), 128)),
                                  _createTextVNode(" ... "),
                                  _createElementVNode("div", _hoisted_106, "共" + _toDisplayString(_ctx.delay_approval_uids_all.length) + "人", 1),
                                  _createVNode(_component_van_icon, {
                                    name: "arrow",
                                    color: "#999999",
                                    size: "14",
                                    style: {"margin-left":"auto"}
                                  })
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
                ])
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.close.close_time_name)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                _hoisted_107,
                _createElementVNode("div", _hoisted_108, [
                  _createElementVNode("div", _hoisted_109, [
                    _hoisted_110,
                    _createElementVNode("div", _hoisted_111, _toDisplayString(_ctx.close.close_time_name), 1)
                  ]),
                  _createElementVNode("div", _hoisted_112, [
                    _hoisted_113,
                    _createElementVNode("div", _hoisted_114, [
                      _createTextVNode(_toDisplayString(_ctx.close.close_reason) + " ", 1),
                      (_ctx.close_state == '1' && _ctx.close.reason_desc_arr.length > 0)
                        ? (_openBlock(), _createElementBlock("i", {
                            key: 0,
                            style: {"color":"#3d6eeb"},
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (
                _ctx.$router.push({
                  name: _ctx.$RouterName.EVENTS_DETAIL,
                  params: {
                    id: _ctx.close.reason_desc_arr[0].id
                  }
                })
              ))
                          }, " : " + _toDisplayString(_ctx.close.reason_desc_arr[0].event_code), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  (_ctx.close.pic_ids_lists.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_115, [
                        _hoisted_116,
                        _createElementVNode("div", _hoisted_117, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.close.pic_ids_lists, (photo) => {
                            return (_openBlock(), _createBlock(_component_van_image, {
                              key: photo.id,
                              style: {"margin-right":"10px"},
                              width: "105px",
                              height: "90px",
                              fit: "cover",
                              src: photo.photo_thumb_file,
                              onClick: ($event: any) => (_ctx.ImagePreview([photo.photo_file]))
                            }, null, 8, ["src", "onClick"]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_118, [
                    _hoisted_119,
                    _createElementVNode("div", _hoisted_120, _toDisplayString(_ctx.close.opt_content || "-"), 1)
                  ]),
                  (_ctx.approvalList.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_121, [
                        _hoisted_122,
                        _createElementVNode("div", _hoisted_123, [
                          _createElementVNode("div", {
                            class: "approval-content",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.approvalState.show = true))
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.approvalList, (approval, index) => {
                              return _withDirectives((_openBlock(), _createBlock(_component_van_image, {
                                key: approval.id,
                                round: "",
                                width: "24px",
                                height: "24px",
                                style: _normalizeStyle({ marginLeft: index > 0 ? '-6px' : '0px' }),
                                src: approval.head_pic
                              }, null, 8, ["style", "src"])), [
                                [_vShow, index < 6]
                              ])
                            }), 128)),
                            _createTextVNode(" ... "),
                            _createElementVNode("div", _hoisted_124, "共" + _toDisplayString(_ctx.approvalList.length) + "人", 1),
                            _createVNode(_component_van_icon, {
                              name: "arrow",
                              color: "#999999",
                              size: "14",
                              style: {"margin-left":"auto"}
                            })
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.is_evaluate === '1')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                _hoisted_125,
                _createElementVNode("div", _hoisted_126, [
                  _createElementVNode("div", _hoisted_127, [
                    _hoisted_128,
                    _createElementVNode("div", _hoisted_129, _toDisplayString(_ctx.praise.send_time_name), 1)
                  ]),
                  _createElementVNode("div", _hoisted_130, [
                    _hoisted_131,
                    _createElementVNode("div", _hoisted_132, [
                      _createElementVNode("div", null, _toDisplayString(_ctx.praise.praise_notes), 1),
                      (_ctx.praise.praise_pic_lists.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_133, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.praise.praise_pic_lists, (photo) => {
                              return (_openBlock(), _createBlock(_component_van_image, {
                                key: photo.id,
                                style: {"margin-right":"3%","border-radius":"8px","overflow":"hidden"},
                                width: "30%",
                                height: "90px",
                                fit: "cover",
                                src: photo.photo_thumb_file,
                                onClick: ($event: any) => (_ctx.ImagePreview([photo.photo_file]))
                              }, null, 8, ["src", "onClick"]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_134, [
                    _hoisted_135,
                    _createElementVNode("div", _hoisted_136, [
                      _createVNode(_component_van_rate, {
                        modelValue: _ctx.praise.speed_result,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.praise.speed_result) = $event)),
                        size: 25,
                        readonly: "",
                        color: "#FFB62F"
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_137, [
                    _hoisted_138,
                    _createElementVNode("div", _hoisted_139, [
                      _createVNode(_component_van_rate, {
                        modelValue: _ctx.praise.serve_result,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.praise.serve_result) = $event)),
                        size: 25,
                        readonly: "",
                        color: "#FFB62F"
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_140, [
                    _hoisted_141,
                    _createElementVNode("div", _hoisted_142, [
                      _createVNode(_component_van_rate, {
                        modelValue: _ctx.praise.professional_result,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.praise.professional_result) = $event)),
                        size: 25,
                        readonly: "",
                        color: "#FFB62F"
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ])
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.opt_lists.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_143, [
                _createElementVNode("div", _hoisted_144, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.opt_lists, (button) => {
                    return (_openBlock(), _createBlock(_component_van_button, {
                      key: button.button_key,
                      class: "btn",
                      block: "",
                      color: "#3d6eeb",
                      square: "",
                      type: "success",
                      onClick: ($event: any) => (_ctx.buttonClick(button.button_key))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(button.button_name), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_exanube, {
            show: _ctx.exanubeState.show,
            "onUpdate:show": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.exanubeState.show) = $event)),
            onSubmit: _ctx.exanubeState.submit
          }, null, 8, ["show", "onSubmit"]),
          _createVNode(_component_praise, {
            show: _ctx.praiseState.show,
            "onUpdate:show": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.praiseState.show) = $event)),
            onSubmit: _ctx.praiseState.submit
          }, null, 8, ["show", "onSubmit"]),
          _createVNode(_component_approval, {
            show: _ctx.approvalState.show,
            "onUpdate:show": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.approvalState.show) = $event)),
            list: _ctx.approvalList
          }, null, 8, ["show", "list"]),
          _createVNode(_component_approval, {
            show: _ctx.approvalState.show2,
            "onUpdate:show": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.approvalState.show2) = $event)),
            list: _ctx.delay_approval_uids_all
          }, null, 8, ["show", "list"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showLock)
      ? (_openBlock(), _createBlock(_component_van_empty, {
          key: 1,
          class: "custom-image",
          image: require('@/assets/icon_lock.png'),
          description: "暂无查看权限"
        }, null, 8, ["image"]))
      : _createCommentVNode("", true),
    _createVNode(_component_van_overlay, { show: _ctx.overlayShow }, {
      default: _withCtx(() => [
        _createVNode(_component_van_loading, {
          size: "24px",
          vertical: "",
          color: "#ffffff",
          style: {"color":"#fff"}
        }, {
          default: _withCtx(() => [
            _hoisted_145
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}